module.exports = {
  Monday: 'Segunda-feira',
  Tuesday: 'Terça-feira',
  Wednesday: 'Quarta-feira',
  Thursday: 'Quinta-feira',
  Friday: 'Sexta-feira',
  Saturday: 'Sábado',
  Sunday: 'Domingo',
  CollectSuccess: 'Collect success',
  StoreSuccess: 'Pronto!\nPacote recebido',
  ReturnSuccess: 'Return success',
  Success: 'Success',
  Exp: 'Exp.',
  UnStored: 'Unstored',
  Stored: 'Stored',
  ExpiredReturned: 'Expired returned',
  Returns: 'Returns',
  Returned: 'Returned',
  Arriving: 'Arriving',
  Collected: 'Collected',
  Created: 'Created',
  Cancelled: 'Cancelled',
  Store: 'Store',
  Collect: 'Collect',
  common: {
    Back: 'Voltar',
    locationName: '',
    Home: 'Início',
    Save: 'Salvar',
    Confirm: 'Confirmar',
    ScanNext: 'Escanear código',
    Cancel: 'Cancelar',
    ScanBarcode: 'Scan barcode',
    ScanToStore: 'Scan to store',
    ScanToReturn: 'Scan to return',
    monthArr: new Array('Jan', 'Fev', 'Mar', 'Abr', 'Mai', 'Jun', 'Jul', 'Ago', 'Set', 'Out', 'Nov', 'Dez'),
    weekArr: new Array('Segunda-feira', 'Terça-feira', 'Quarta-feira', 'Quinta-feira', 'Sexta-feira', 'Sábado', 'Domingo'),
    dayFormat: '',
    space: ' ',
    loadMore: 'Carregar mais...',
    finishLoading: 'Carregamento concluído',
    noMore: 'Não mais'
  },
  login: {
    LoginTitle: 'Acesse o LoggiPonto',
    Login: 'Entrar',
    Username: 'E-mail',
    Password: 'Senha'
  },
  bottom: {
    line: 'CS Hotline: '
  },
  index: {
    profile: 'Meu perfil',
    locationName: '',
    Arriving: 'Previsto',
    Stored: 'Coletado',
    Collected: 'Entregue',
    Returns: 'Para distribuir',
    Store: 'Receber',
    Collect: 'Entregar para cliente',
    Courier: 'Distribuir transportadora',
    expired: 'Distribuir vencidos',
    OrderId: 'Código do pacote, ',
    PhoneNumber: 'telefone'
  },
  profile: {
    TodayLogs: 'Hoje',
    Total: 'Total',
    ThisMonth: 'Este mês',
    LocationID: 'Identificação do LoggiPonto',
    LocationName: 'Nome do LoggiPonto',
    Address: 'Endereço',
    ShopContact: 'Contato',
    Username: 'E-mail',
    RegisteredPhoneNumber: 'Telefone de cadastro',
    BusinessHours: 'Horário de funcionamento',
    Edit: 'Editar',
    Logout: 'Sair'
  },
  editProfile: {
    EditProfile: 'Editar perfil',
    LocationID: 'Identificação do LoggiPonto',
    LocationNameEnglish: 'Nome do LoggiPonto',
    LocationNameChinese: 'Location name (Chinese)',
    AddressEnglish: 'Endereço',
    AddressChinese: 'Address (Chinese)',
    Username: 'E-mail',
    RegisteredPhoneNnumber: 'Telefone de cadastro',
    BusinessHours: 'Horário de funcionamento',
    ShopContact: 'Contato',
    Monday: 'Segunda-feira',
    Tuesday: 'Terça-feira',
    Wednesday: 'Quarta-feira',
    Thursday: 'Quinta-feira',
    Friday: 'Sexta-feira',
    Saturday: 'Sábado',
    Sunday: 'Domingo',
    Rest: 'Fechado',
    AddMoreHours: 'Adicionar horário',
    OpenHours: 'Aberto 24 horas',
    ExceptionsOrHolidays: 'Exceções ou feriados',
    AddSpecialHours: 'Adicionar ou remover horário de funcionamento especial',
    Open: 'Abertura',
    Close: 'Fechamento',
    SelectSpecialDays: 'Selecionar dias especiais',
    OK: 'OK',
    Cancel: 'Cancelar'
  },
  selectCompany: {
    ReturnCourier: 'Distribuir para transportadora',
    ReturnExpired: 'Distribuir vencidos'
  },
  editRemark: {},
  expired: {
    Returns: 'Returns',
    Expired: 'Expired'
  },
  barCode: {
    PleaseAim: 'Posicione o código de barras na marcação',
    manually: 'Digitar código',
    Loading: 'Carregando...',
    mismatch: 'This parcel does not match the PIN code'
  },
  qrCode: {
    PleaseAim: 'Please aim at the QR code',
    manually: 'Digitar PIN'
  },
  enterBarCode: {
    EnterBarcode: 'Digitar código de barras',
    EnterName: 'Digite o nome do recebedor',
    EnterID: 'Digite o CPF do recebedor'
  },
  enterPIN: {
    EnterPIN: 'Digitar número do PIN',
    ScanApp: 'Bipar Código QR'
  },
  success: {
    Note: 'Notas (Opcional):\nExemplo: O pacote está na segunda prateleira',
    ScanParcel: 'Bipar localização do pacote',
    EditNote: 'Edit notes',
    CollectSuccess: 'Collect success',
    StoreSuccess: 'Pronto!\nPacote recebido',
    ReturnSuccess: 'Return success',
    Success: 'Success'
  },
  details: {
    OrderDetails: 'Detalhes do pacote',
    OrderID: 'ID do pacote',
    Logistics: 'Transportadora',
    Recipient: 'Recebedor',
    TimeStored: 'Coletado em',
    Notes: 'Notas',
    Edit: 'Editar',
    ScanBarcode: 'Scan barcode',
    ScanToStore: 'Scan to store',
    ScanToReturn: 'Scan to return',
    TimeCollected: 'Time collected',
    EditNotes: 'Editar notas',
    ScanParcel: 'Bipar localização do pacote'
  },
  total: {
    Total: 'Total',
    Completed: 'Completed',
    InProgress: 'In progress'
  },
  todayLogs: {
    TodayLogs: 'Today logs'
  },
  month: {
    TimeStored: 'Recebido em',
    TimeCollected: 'Time collected'
  },
  thisMonth: {
    ThisMonth: 'This month'
  },
  searchResult: {
    CannotFind: 'Cannot find the order',
    TimeStored: 'Recebido em',
    TimeCollected: 'Time collected',
    TimeReturned: 'Time returned'
  }
}



// WEBPACK FOOTER //
// ./src/assets/lang/br.js